import cn from "classnames";

import "./SpinLoader.module.scss";

export const POSITION_ABSOLUTE = "l-absolute";
export const POSITION_FIXED = "l-fixed";
export const POSITION_STATIC = "l-static";

export const LOADER_COLOR_WHITE = "l-white";
export const LOADER_COLOR_RED = "l-red";
export const LOADER_COLOR_BLUE = "l-blue";
export const LOADER_COLOR_DARK = "l-dark";

export const LOADER_SIZE_LARGE = "l-large";
export const LOADER_SIZE_MEDIUM = "l-medium";
export const LOADER_SIZE_SMALL = "l-small";

type Props = {
  color: string;
  position?: string;
  size?: string;
  withBlur?: boolean;
  customClass?: string | null;
};

const SpinLoader = ({
  position = POSITION_ABSOLUTE,
  size = LOADER_SIZE_LARGE,
  color = LOADER_COLOR_BLUE,
  withBlur = false,
  customClass = null,
}: Props) => {
  return (
    <>
      {withBlur && (
        <div className={cn("spin-loader-blur", position, customClass)} />
      )}
      <div className={cn("spin-loader", position, size, color, customClass)}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </>
  );
};

export default SpinLoader;
